import { createI18n } from 'vue-i18n';

const messages = {
  it: {
    nav: {
      home: 'Home',
      about: 'Chi Siamo',
      fleet: 'Veicoli',
      offers: 'Offerte',
      contact: 'Contatti'
    },
    hero: {
      title: 'Benvenuti in Pizzoni Viaggi',
      subtitle: 'Il tuo viaggio inizia qui',
      cta: 'Scopri le Offerte'
    },
    about: {
      title: 'Chi Siamo',
      description: 'Work in Progress'
    },
    offers: {
      title: 'Le Nostre Ultime Offerte'
    },
    fleet: {
      title: 'I Nostri Veicoli',
      subtitle: 'Mezzi moderni e confortevoli per ogni esigenza di viaggio',
      seats: 'posti',
      year: 'Anno',
      vehicle1Description: 'Work in Progress',
      vehicle2Description: 'Work in Progress',
      airConditioning: 'Aria Condizionata',
      tvMonitor: 'TV/Monitor',
      audioStereo: 'Audio Stereo',
      recliningSeats: 'Sedili Reclinabili',
      comfortSeats: 'Sedili Comfort',
      toilet: 'WC a bordo',
      wifi: 'WiFi'
    },
    contact: {
      title: 'Orari di Apertura',
      monday: 'Lunedì',
      tuesday: 'Martedì',
      wednesday: 'Mercoledì',
      thursday: 'Giovedì',
      friday: 'Venerdì',
      saturday: 'Sabato',
      sunday: 'Domenica',
      closed: 'Chiuso'
    },
    footer: {
      company: 'Pizzoni Viaggi',
      legalSeat: 'Sede Legale',
      operationalSeat: 'Sede Operativa',
      phone: 'Telefono',
      quickLinks: 'Link Rapidi',
      followUs: 'Seguici',
      rights: 'Tutti i diritti riservati'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About Us',
      fleet: 'Vehicles',
      offers: 'Offers',
      contact: 'Contact'
    },
    hero: {
      title: 'Welcome to Pizzoni Viaggi',
      subtitle: 'Your journey starts here',
      cta: 'Discover Offers'
    },
    about: {
      title: 'About Our Company',
      description: 'Work in Progress'
    },
    offers: {
      title: 'Our Latest Offers'
    },
    fleet: {
      title: 'Our Vehicles',
      subtitle: 'Modern and comfortable vehicles for every travel need',
      seats: 'seats',
      year: 'Year',
      vehicle1Description: 'Work in Progress',
      vehicle2Description: 'Work in Progress',
      airConditioning: 'Air Conditioning',
      tvMonitor: 'TV/Monitor',
      audioStereo: 'Audio Stereo',
      recliningSeats: 'Reclining Seats',
      comfortSeats: 'Comfort Seats',
      toilet: 'Onboard WC',
      wifi: 'WiFi'
    },
    contact: {
      title: 'Opening Hours',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      closed: 'Closed'
    },
    footer: {
      company: 'Pizzoni Viaggi',
      legalSeat: 'Registered Office',
      operationalSeat: 'Operational Headquarters',
      phone: 'Phone',
      quickLinks: 'Quick Links',
      followUs: 'Follow Us',
      rights: 'All rights reserved',
      email: 'Email'
    }
  }
};

// Detect user's country/language
function getDefaultLocale() {
  const browserLang = navigator.language || navigator.userLanguage;
  if (browserLang.startsWith('it')) {
    return 'it';
  }
  return 'en';
}

const i18n = createI18n({
  legacy: false,
  locale: getDefaultLocale(),
  fallbackLocale: 'en',
  messages
});

export default i18n;
